export enum TmToastPosture {
    Danger = 'danger',
    Success = 'success',
}
